/**
 * UpdatedAgo — 카드 머리의 "갱신 3분 전" 상대시각 (2026-10-23).
 *
 * - 30초마다 다시 그려 자동 조회가 멈춰도 "n분 전"이 늘어난다(오래된 자료가 저절로 드러남).
 * - 마우스를 올리면 정확한 시각("14:32:05 갱신").
 * - loading 이면 "조회 중…", 아직 시각이 없으면 "—".
 *
 * 헤더 알약(SyncStatusPill)이 없는 카드 머리용. 본보기 Dashboard.tsx 금일 출하 내용.
 */
import { useAgo } from "@/hooks/useAgo";

type Props = {
  /** 마지막 갱신 시각. null = 아직 없음 */
  at: Date | null;
  loading?: boolean;
};

export function UpdatedAgo({ at, loading = false }: Props) {
  const ago = useAgo(at);
  if (loading) return <span>조회 중…</span>;
  if (!at) return <span>—</span>;
  return (
    <time dateTime={at.toISOString()} title={`${at.toLocaleTimeString("ko-KR", { hour12: false })} 갱신`}>
      갱신 {ago}
    </time>
  );
}
